import React, {Component} from 'react'
import CustomTable from '../../../../../elements/Table/CustomTable'
import {Button} from 'antd'

class SalikList extends Component {
  componentDidMount() {
    this.props.fetchSalik()
  }

  columns = [
    {
      Header: 'System ID',
      accessor: '_key',
      Cell: ({value, original}) => (
        <a onClick={() => this.props.onShowDelivery(original)}>{value}</a>
      ),
    },
    {
      Header: 'salikId',
      accessor: 'salikId',
    },
    {
      Header: 'tripDate',
      accessor: 'tripDate',
    },
    {Header: 'postDate', accessor: 'postDate'},
    {Header: 'plate', accessor: 'plate'},
    {Header: 'amount', accessor: 'amount'},
    {Header: 'direction', accessor: 'direction'},
    {Header: 'tag', accessor: 'tag'},
    {Header: 'tollGate', accessor: 'tollGate'},
    {Header: 'account', accessor: 'account'},
    {Header: 'tripTime', accessor: 'tripTime'},
    {Header: 'processed', accessor: 'processed.state'},
  ]

  render() {
    const {salikList, fetchSalik, onShowSalik, fetchingSalik} = this.props
    return (
      <CustomTable
        CreateButton={() => (
          <Button
            type={'primary'}
            onClick={onShowSalik}
            size={'small'}
            icon={'plus'}>
            Upload CSV
          </Button>
        )}
        columns={this.columns}
        data={salikList}
        fetch={fetchSalik}
        fetching={fetchingSalik}
      />
    )
  }
}

SalikList.propTypes = {}
SalikList.defaultProps = {}

export default SalikList
